// src/api/SuperAdminApi.js
import axios from 'axios';
import { handleApiError } from './handleApiError';

const API_BASE_URL =
  process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

export const apiOnboardCompany = async (token, companyData) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/auth/api/superadmin/onboard-company`,
      companyData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );
    return {
      status: true,
      data: response.data,
      message: response.data.message,
    };
  } catch (error) {
    return handleApiError(error, 'apiOnboardCompany');
  }
};

export const apiImpersonateUser = async (token, targetUid) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/auth/api/superadmin/impersonate`,
      { targetUid },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );
    return { status: true, data: response.data };
  } catch (error) {
    return handleApiError(error, 'apiImpersonateUser');
  }
};

export const apiFetchAllSystemUsers = async (token) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/auth/api/superadmin/all-system-users`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return { status: true, data: response.data };
  } catch (error) {
    return handleApiError(error, 'apiFetchAllSystemUsers');
  }
};

export const apiFetchSystemInvoices = async (token) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/auth/api/superadmin/invoices`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return { status: true, data: response.data };
  } catch (error) {
    return handleApiError(error, 'apiFetchSystemInvoices');
  }
};

export const apiMarkInvoicePaid = async (token, invoiceId) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/auth/api/superadmin/invoices/${invoiceId}/mark-paid`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );
    return { status: true, message: response.data.message };
  } catch (error) {
    return handleApiError(error, 'apiMarkInvoicePaid');
  }
};

export const apiGenerateInvoices = async (token) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/auth/api/superadmin/invoices/generate`,
      {},
      { headers: { Authorization: `Bearer ${token}` } },
    );
    return { status: true, message: response.data.message };
  } catch (error) {
    return handleApiError(error, 'apiGenerateInvoices');
  }
};

export const apiDispatchInvoices = async (token, targetMonth = null) => {
  try {
    // FORCE targetMonth to only be a string or null.
    // If an object (like a React Event) slipped through, discard it.
    const safeTargetMonth =
      typeof targetMonth === 'string' ? targetMonth : null;

    // Build a clean payload
    const payload = safeTargetMonth ? { billing_month: safeTargetMonth } : {};

    const response = await axios.post(
      `${API_BASE_URL}/auth/api/superadmin/invoices/dispatch`,
      payload, // Now guaranteed to be clean JSON
      { headers: { Authorization: `Bearer ${token}` } },
    );
    return {
      status: true,
      message: response.data.message,
      data: response.data,
    };
  } catch (error) {
    return handleApiError(error, 'apiDispatchInvoices');
  }
};

export const apiFetchSystemWalletTransactions = async (token) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/auth/api/superadmin/wallet-transactions`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return { status: true, data: response.data };
  } catch (error) {
    return handleApiError(error, 'apiFetchSystemWalletTransactions');
  }
};

export const apiSuperAdminScrapeWebsite = async (
  token,
  targetCompanyId,
  url,
) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/auth/api/superadmin/onboard-url`, // Match your backend route
      { targetCompanyId, url },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );
    return {
      status: true,
      data: response.data,
      message: response.data.message,
    };
  } catch (error) {
    return handleApiError(error, 'apiSuperAdminScrapeWebsite');
  }
};
